import { LogLevel, Qualify } from "@larva.io/report-definitions";

export interface LogEntry {
  id: string | number;
  createdAt: string;
  code: number;
  level: LogLevel;
  qualify: Qualify;
  data: any | undefined | null;
}

export interface InputMessage {
  count: number;
  logs: LogEntry[];
}
